export const REQUEST_STATES = {
  Initial: "initial",
  Pending: "pending",
  Success: "success",
  Error: "error",
};
